import { withInstall } from '@vuemap/vue-amap-util'
import HawkEye from './HawkEye.vue'

export const ElAmapControlHawkEye = withInstall(HawkEye)
export default ElAmapControlHawkEye
